import { subscribe as Ae } from "@seamless/one-context";
import { ref as p, computed as d, toValue as f, watch as k, useSSRContext as W, onMounted as ne, unref as pe, getCurrentScope as _e, onScopeDispose as me, getCurrentInstance as ve, onBeforeMount as Le } from "vue";
import { initializeLogger as he } from "@seamless/logger";
import { initializeStore as se, SeamlessConnection as ge } from "@seamless/store";
import { m as ye } from "./i18n-Cc8soYM3.js";
import { C as Zt, D as Kt, d as Wt, c as Xt, P as Jt, b as en, l as tn, a as nn, u as sn } from "./i18n-Cc8soYM3.js";
import { C as an, S as on, a as un, c as cn, e as ln, l as Sn, b as En, m as dn, r as Cn, u as fn, d as An } from "./useErrorCapturer-LYriEvzM.js";
import { u as _n } from "./useUuid-BHJNgR58.js";
var y = /* @__PURE__ */ ((e) => (e.MERCEDES_BENZ = "Mercedes-Benz", e.MERCEDES_AMG = "Mercedes-AMG", e.MERCEDES_MAYBACH = "Mercedes-Maybach", e))(y || {}), M = /* @__PURE__ */ ((e) => (e.MERCEDES_BENZ = "MERCEDES_BENZ", e.MERCEDES_AMG = "MERCEDES_AMG", e.MERCEDES_MAYBACH = "MERCEDES_MAYBACH", e.MERCEDESBENZ = "Mercedes-Benz", e.MERCEDESAMG = "Mercedes-AMG", e.MERCEDESMAYBACH = "Mercedes-Maybach", e))(M || {}), Q = /* @__PURE__ */ ((e) => (e.AMG = "amg", e.MAYBACH = "maybach", e))(Q || {}), Me;
function be(e) {
  return Me?.get(e);
}
var Re;
function Te(e) {
  return Re?.get(e);
}
var Oe;
function Ie(e, n) {
  return Oe?.get(e)?.get(n);
}
function re(e) {
  const n = typeof e;
  return n === "string" ? `"${e}"` : n === "number" || n === "bigint" || n === "boolean" ? `${e}` : n === "object" || n === "function" ? (e && Object.getPrototypeOf(e)?.constructor?.name) ?? "null" : n;
}
function _(e, n, t, r, o) {
  const a = o && "input" in o ? o.input : t.value, u = o?.expected ?? e.expects ?? null, c = o?.received ?? re(a), i = {
    kind: e.kind,
    type: e.type,
    input: a,
    expected: u,
    received: c,
    message: `Invalid ${n}: ${u ? `Expected ${u} but r` : "R"}eceived ${c}`,
    requirement: e.requirement,
    path: o?.path,
    issues: o?.issues,
    lang: r.lang,
    abortEarly: r.abortEarly,
    abortPipeEarly: r.abortPipeEarly
  }, l = e.kind === "schema", S = o?.message ?? e.message ?? Ie(e.reference, i.lang) ?? (l ? Te(i.lang) : null) ?? r.message ?? be(i.lang);
  S && (i.message = typeof S == "function" ? (
    // @ts-expect-error
    S(i)
  ) : S), l && (t.typed = !1), t.issues ? t.issues.push(i) : t.issues = [i];
}
function ae(e, n) {
  const t = [...new Set(e)];
  return t.length > 1 ? `(${t.join(` ${n} `)})` : t[0] ?? "never";
}
function D(e, n) {
  return {
    kind: "validation",
    type: "max_length",
    reference: D,
    async: !1,
    expects: `<=${e}`,
    requirement: e,
    message: n,
    _run(t, r) {
      return t.typed && t.value.length > this.requirement && _(this, "length", t, r, {
        received: `${t.value.length}`
      }), t;
    }
  };
}
function N(e, n) {
  return {
    kind: "validation",
    type: "min_length",
    reference: N,
    async: !1,
    expects: `>=${e}`,
    requirement: e,
    message: n,
    _run(t, r) {
      return t.typed && t.value.length < this.requirement && _(this, "length", t, r, {
        received: `${t.value.length}`
      }), t;
    }
  };
}
function q(e, n) {
  return {
    kind: "validation",
    type: "regex",
    reference: q,
    async: !1,
    expects: `${e}`,
    requirement: e,
    message: n,
    _run(t, r) {
      return t.typed && !this.requirement.test(t.value) && _(this, "format", t, r), t;
    }
  };
}
function T(e) {
  return {
    kind: "transformation",
    type: "transform",
    reference: T,
    async: !1,
    operation: e,
    _run(n) {
      return n.value = this.operation(n.value), n;
    }
  };
}
function we(e, n, t) {
  return typeof e.fallback == "function" ? (
    // @ts-expect-error
    e.fallback(n, t)
  ) : (
    // @ts-expect-error
    e.fallback
  );
}
function De(e, n) {
  return {
    ...e,
    fallback: n,
    _run(t, r) {
      const o = e._run(t, r);
      return o.issues ? { typed: !0, value: we(this, o, r) } : o;
    }
  };
}
function Ne(e, n, t) {
  return typeof e.default == "function" ? (
    // @ts-expect-error
    e.default(n, t)
  ) : (
    // @ts-expect-error
    e.default
  );
}
function b(e, n) {
  return {
    kind: "schema",
    type: "array",
    reference: b,
    expects: "Array",
    async: !1,
    item: e,
    message: n,
    _run(t, r) {
      const o = t.value;
      if (Array.isArray(o)) {
        t.typed = !0, t.value = [];
        for (let a = 0; a < o.length; a++) {
          const u = o[a], c = this.item._run({ typed: !1, value: u }, r);
          if (c.issues) {
            const i = {
              type: "array",
              origin: "value",
              input: o,
              key: a,
              value: u
            };
            for (const l of c.issues)
              l.path ? l.path.unshift(i) : l.path = [i], t.issues?.push(l);
            if (t.issues || (t.issues = c.issues), r.abortEarly) {
              t.typed = !1;
              break;
            }
          }
          c.typed || (t.typed = !1), t.value.push(c.value);
        }
      } else
        _(this, "type", t, r);
      return t;
    }
  };
}
function z(e, n) {
  if (typeof e == typeof n) {
    if (e === n || e instanceof Date && n instanceof Date && +e == +n)
      return { value: e };
    if (e && n && e.constructor === Object && n.constructor === Object) {
      for (const t in n)
        if (t in e) {
          const r = z(e[t], n[t]);
          if (r.issue)
            return r;
          e[t] = r.value;
        } else
          e[t] = n[t];
      return { value: e };
    }
    if (Array.isArray(e) && Array.isArray(n) && e.length === n.length) {
      for (let t = 0; t < e.length; t++) {
        const r = z(e[t], n[t]);
        if (r.issue)
          return r;
        e[t] = r.value;
      }
      return { value: e };
    }
  }
  return { issue: !0 };
}
function oe(e, n) {
  return {
    kind: "schema",
    type: "intersect",
    reference: oe,
    expects: ae(
      e.map((t) => t.expects),
      "&"
    ),
    async: !1,
    options: e,
    message: n,
    _run(t, r) {
      if (this.options.length) {
        const o = t.value;
        let a;
        t.typed = !0;
        for (const u of this.options) {
          const c = u._run(
            { typed: !1, value: o },
            r
          );
          if (c.issues && (t.issues ? t.issues.push(...c.issues) : t.issues = c.issues, r.abortEarly)) {
            t.typed = !1;
            break;
          }
          c.typed || (t.typed = !1), t.typed && (a ? a.push(c.value) : a = [c.value]);
        }
        if (t.typed) {
          t.value = a[0];
          for (let u = 1; u < a.length; u++) {
            const c = z(t.value, a[u]);
            if (c.issue) {
              _(this, "type", t, r, {
                received: "unknown"
              });
              break;
            }
            t.value = c.value;
          }
        }
      } else
        _(this, "type", t, r);
      return t;
    }
  };
}
function s(e, n) {
  return {
    kind: "schema",
    type: "literal",
    reference: s,
    expects: re(e),
    async: !1,
    literal: e,
    message: n,
    _run(t, r) {
      return t.value === this.literal ? t.typed = !0 : _(this, "type", t, r), t;
    }
  };
}
function ie(e, ...n) {
  const t = {
    kind: "schema",
    type: "nullish",
    reference: ie,
    expects: `(${e.expects} | null | undefined)`,
    async: !1,
    wrapped: e,
    _run(r, o) {
      return (r.value === null || r.value === void 0) && ("default" in this && (r.value = Ne(
        this,
        r,
        o
      )), r.value === null || r.value === void 0) ? (r.typed = !0, r) : this.wrapped._run(r, o);
    }
  };
  return 0 in n && (t.default = n[0]), t;
}
function I(e, n) {
  return {
    kind: "schema",
    type: "object",
    reference: I,
    expects: "Object",
    async: !1,
    entries: e,
    message: n,
    _run(t, r) {
      const o = t.value;
      if (o && typeof o == "object") {
        t.typed = !0, t.value = {};
        for (const a in this.entries) {
          const u = o[a], c = this.entries[a]._run(
            { typed: !1, value: u },
            r
          );
          if (c.issues) {
            const i = {
              type: "object",
              origin: "value",
              input: o,
              key: a,
              value: u
            };
            for (const l of c.issues)
              l.path ? l.path.unshift(i) : l.path = [i], t.issues?.push(l);
            if (t.issues || (t.issues = c.issues), r.abortEarly) {
              t.typed = !1;
              break;
            }
          }
          c.typed || (t.typed = !1), (c.value !== void 0 || a in o) && (t.value[a] = c.value);
        }
      } else
        _(this, "type", t, r);
      return t;
    }
  };
}
function B(e) {
  return {
    kind: "schema",
    type: "string",
    reference: B,
    expects: "string",
    async: !1,
    message: e,
    _run(n, t) {
      return typeof n.value == "string" ? n.typed = !0 : _(this, "type", n, t), n;
    }
  };
}
function X(e) {
  let n;
  if (e)
    for (const t of e)
      n ? n.push(...t.issues) : n = t.issues;
  return n;
}
function m(e, n) {
  return {
    kind: "schema",
    type: "union",
    reference: m,
    expects: ae(
      e.map((t) => t.expects),
      "|"
    ),
    async: !1,
    options: e,
    message: n,
    _run(t, r) {
      let o, a, u;
      for (const c of this.options) {
        const i = c._run(
          { typed: !1, value: t.value },
          r
        );
        if (i.typed)
          if (i.issues)
            a ? a.push(i) : a = [i];
          else {
            o = i;
            break;
          }
        else
          u ? u.push(i) : u = [i];
      }
      if (o)
        return o;
      if (a) {
        if (a.length === 1)
          return a[0];
        _(this, "type", t, r, {
          issues: X(a)
        }), t.typed = !0;
      } else {
        if (u?.length === 1)
          return u[0];
        _(this, "type", t, r, {
          issues: X(u)
        });
      }
      return t;
    }
  };
}
function Be(e, n) {
  const t = {
    ...e.entries
  };
  for (const r of n)
    delete t[r];
  return { ...e, entries: t };
}
function v(...e) {
  return {
    ...e[0],
    pipe: e,
    _run(n, t) {
      for (const r of e)
        if (r.kind !== "metadata") {
          if (n.issues && (r.kind === "schema" || r.kind === "transformation")) {
            n.typed = !1;
            break;
          }
          (!n.issues || !t.abortEarly && !t.abortPipeEarly) && (n = r._run(n, t));
        }
      return n;
    }
  };
}
const O = {
  MERCEDES_BENZ: "Mercedes-Benz",
  MERCEDES_AMG: "Mercedes-AMG",
  MERCEDES_MAYBACH: "Mercedes-Maybach",
  get "Mercedes-Benz"() {
    return O.MERCEDES_BENZ;
  },
  get "Mercedes-AMG"() {
    return O.MERCEDES_AMG;
  },
  get "Mercedes-Maybach"() {
    return O.MERCEDES_MAYBACH;
  },
  get amg() {
    return O.MERCEDES_AMG;
  },
  get maybach() {
    return O.MERCEDES_MAYBACH;
  }
}, ue = /^[a-zA-Z]{2}$/, ke = m([v(B(), N(4), D(4)), s("")]), ce = v(
  B(),
  N(2),
  D(2),
  q(ue, "Must match two-letter pattern")
), le = v(
  B(),
  N(2),
  D(2),
  q(ue, "Must match two-letter pattern")
), Se = ie(v(B(), N(3), D(5)));
m([v(B(), N(1), D(28)), s("")]);
const j = De(
  m([
    s("MERCEDES_BENZ"),
    s("MERCEDES_AMG"),
    s("MERCEDES_MAYBACH"),
    s("Mercedes-Benz"),
    s("Mercedes-AMG"),
    s("Mercedes-Maybach")
  ]),
  "Mercedes-Benz"
), Ge = m([
  s("BODY_TYPE"),
  s("FUEL_TYPE"),
  s("PRICE"),
  s("POWER"),
  s("MODEL"),
  s("BRAND"),
  s("LINE"),
  s("COLOR_GROUP"),
  s("")
]), Pe = m([
  s("ELECTRIC"),
  s("PETROL"),
  s("DIESEL"),
  s("HYBRID"),
  s("")
]);
m([
  s("DISABLED"),
  s("CITAN"),
  s("CITAN_PANEL_VAN"),
  s("CITAN_MIXTO"),
  s("CITAN_TOURER"),
  s("MARCO_POLO"),
  s("SPRINTER"),
  s("SPRINTER_CHASSIS"),
  s("SPRINTER_CHASSIS_CREW_CAB"),
  s("SPRINTER_PANEL_VAN"),
  s("SPRINTER_TOURER"),
  s("T_CLASS"),
  s("V_CLASS"),
  s("VITO"),
  s("VITO_PANEL_VAN"),
  s("VITO_MIXTO"),
  s("VITO_TOURER"),
  s("eCITAN"),
  s("eCITAN_TOURER"),
  s("eCITAN_PANEL_VAN"),
  s("eSPRINTER"),
  s("eVITO"),
  s("eVITO_TOURER"),
  s("eVITO_PANEL_VAN"),
  s("EQT_CLASS"),
  s("EQV_CLASS")
]);
m([
  s("DISABLED"),
  s("HATCHBACK"),
  s("LIMOUSINE"),
  s("CABRIO"),
  s("COUPE"),
  s("STATION"),
  s("SHOOTING_BRAKE"),
  s("SUV"),
  s("ROADSTER"),
  s("LONG_SEDAN"),
  s("A_CLASS"),
  s("A_CLASS_HATCHBACK"),
  s("A_CLASS_LIMOUSINE"),
  s("B_CLASS"),
  s("C_CLASS"),
  s("C_CLASS_CABRIO"),
  s("C_CLASS_COUPE"),
  s("C_CLASS_LIMOUSINE"),
  s("C_CLASS_STATION"),
  s("CLA_CLASS"),
  s("CLA_CLASS_COUPE"),
  s("CLA_CLASS_SHOOTING_BRAKE"),
  s("CLS_CLASS"),
  s("E_CLASS"),
  s("E_CLASS_STATION"),
  s("E_CLASS_CABRIO"),
  s("E_CLASS_LIMOUSINE"),
  s("EQA_CLASS"),
  s("EQB_CLASS"),
  s("EQC_CLASS"),
  s("EQE_CLASS"),
  s("EQE_CLASS_SUV"),
  s("EQE_CLASS_LIMOUSINE"),
  s("EQS_CLASS"),
  s("EQS_CLASS_SUV"),
  s("EQS_CLASS_LIMOUSINE"),
  s("G_CLASS"),
  s("GLA_CLASS"),
  s("GLB_CLASS"),
  s("GLC_CLASS"),
  s("GLC_CLASS_SUV"),
  s("GLC_CLASS_COUPE"),
  s("GLE_CLASS"),
  s("GLS_CLASS"),
  s("GT_CLASS"),
  s("S_CLASS"),
  s("S_CLASS_ROADSTER"),
  s("S_CLASS_LIMOUSINE"),
  s("S_CLASS_LONG_SEDAN"),
  s("SL_CLASS"),
  s("SLK_CLASS"),
  s("SMARTFORTWO"),
  s("X_CLASS")
]);
m([s("DISABLED"), s("B2C"), s("B2B")]);
const $e = m([
  s("A_CLASS"),
  s("B_CLASS"),
  s("C_CLASS"),
  s("CITAN"),
  s("CLA_CLASS"),
  s("CLE_CLASS"),
  s("CLS_CLASS"),
  s("E_CLASS"),
  s("EQA_CLASS"),
  s("EQB_CLASS"),
  s("EQC_CLASS"),
  s("EQE_CLASS"),
  s("EQS_CLASS"),
  s("EQT_CLASS"),
  s("EQV_CLASS"),
  s("G_CLASS"),
  s("GLA_CLASS"),
  s("GLB_CLASS"),
  s("GLC_CLASS"),
  s("GLE_CLASS"),
  s("GLS_CLASS"),
  s("GT_CLASS"),
  s("MARCO_POLO"),
  s("S_CLASS"),
  s("SL_CLASS"),
  s("SLK_CLASS"),
  s("SMARTFORTWO"),
  s("SPRINTER"),
  s("T_CLASS"),
  s("V_CLASS"),
  s("VITO"),
  s("X_CLASS")
]), He = m([
  s("SUV"),
  s("LIMOUSINE"),
  s("PANEL_VAN"),
  s("MIXTO"),
  s("TOURER"),
  s("CHASSIS"),
  s("CHASSIS-CC"),
  s("")
]), G = (e) => Array.isArray(e) ? e.join(",") : "", Ue = (e) => e.map((n) => O[n]), Ve = v(
  b(Ge),
  T((e) => G(e))
), xe = v(
  b(Pe),
  T((e) => G(e))
), Qe = v(
  b(He),
  T((e) => G(e))
), ze = v(
  b(j),
  T(Ue),
  T((e) => G(e))
), Ye = v(
  b($e),
  T((e) => G(e))
), qe = I({
  baumuster4: ke,
  lang: ce,
  market: le,
  stage: Se,
  brand: ze,
  bodyType: Qe,
  clusteringCriteria: Ve,
  fuelTypes: xe
});
oe([
  Be(qe, ["baumuster4"]),
  I({ modelIdentifier: Ye })
]);
const je = I({
  lang: ce,
  market: le,
  stage: Se,
  brand: b(j)
});
I({
  ...je.entries,
  ...I({ brand: b(j) }).entries
});
function Fe(e) {
  switch (e) {
    case y.MERCEDES_AMG:
    case M.MERCEDES_AMG:
    case M.MERCEDESAMG:
    case Q.AMG:
      return y.MERCEDES_AMG;
    case y.MERCEDES_MAYBACH:
    case M.MERCEDES_MAYBACH:
    case M.MERCEDESMAYBACH:
    case Q.MAYBACH:
      return y.MERCEDES_MAYBACH;
    default:
      return y.MERCEDES_BENZ;
  }
}
function Tt(e) {
  const n = p(null), t = p(null), r = d(() => {
    const a = f(e) ?? n.value ?? t.value;
    return Fe(a);
  });
  Ae("PageConnection", {
    tenant: "sccs",
    componentName: "sccs-one-teaser",
    callback: (a) => {
      t.value = a.pageEnvironmentVariables.vehicleData?.subBrands[0], n.value = a.pageEnvironmentVariables.brand?.subBrand;
    }
  });
  const o = d(() => {
    switch (r?.value) {
      case y.MERCEDES_AMG:
        return M.MERCEDESAMG;
      case y.MERCEDES_MAYBACH:
        return M.MERCEDESMAYBACH;
      default:
        return M.MERCEDESBENZ;
    }
  });
  return { subBrand: r, brandUrlParameter: o };
}
function Ze(e) {
  switch (e?.toLowerCase()?.trim() ?? "prod") {
    case "dev":
    case "development":
    case "local":
    case "localhost":
      return "TEST";
    case "int":
    case "integration":
    case "test":
    case "testing":
      return "INT";
    case "pprod":
    case "preprod":
    case "pre-production":
    case "preproduction":
      return "PPROD";
    case "prod":
    case "production":
      return "PROD";
    default:
      return "LOCAL";
  }
}
function Ke(e) {
  return e.toLowerCase().trim();
}
const Ot = "fe-vehicle-tiles", $ = "fe-one-teaser-platform", We = {
  LOCAL: "https://assets.oneweb.mercedes-benz.com",
  TEST: "https://dev.assets.oneweb.mercedes-benz.com",
  INT: "https://int.assets.oneweb.mercedes-benz.com",
  PPROD: "https://preprod.assets.oneweb.mercedes-benz.com",
  PROD: "https://assets.oneweb.mercedes-benz.com"
};
function Xe(e, n, t) {
  const r = We[Ze(e) ?? "PROD"], o = Ke(n);
  return `${r}/config/emh/${t}/${o}/config.json`;
}
const Je = he("DH_IO_SCSS/CONFIG_SERVICE_OT");
function It(e) {
  const n = p(null), t = p(!0), r = p(null), o = new URLSearchParams(window.location.search), a = (C, L, R, h) => {
    const P = $ + "_" + C + "_" + L, F = o.get(P), Z = F ? ["t", "true"].includes(F.toLocaleLowerCase()) : void 0, K = Z ?? R ?? h;
    return Je.log($ + "_" + C + "_" + L + " set to " + K, {
      urlParamResult: Z,
      configServiceResult: R,
      fallback: h
    }), K;
  }, u = d(() => !t.value), c = d(
    () => a("focMarket", "isFocMarket", n.value?.focMarket?.isFocMarket, !1)
  ), i = d(
    () => a(
      "personalization",
      "personalizationEnabled",
      n.value?.personalization?.personalizationEnabled,
      !1
    )
  ), l = d(
    () => a(
      "switchToOneTeaser",
      "enableOneTeaserHome",
      n.value?.switchToOneTeaser?.enableOneTeaserHome,
      !0
    )
  ), S = d(
    () => a(
      "switchToOneTeaser",
      "enableOneTeaserCampaign",
      n.value?.switchToOneTeaser?.enableOneTeaserCampaign,
      !0
    )
  ), E = d(
    () => a("config", "failOnMissingPrice", n.value?.config?.failOnMissingPrice, !0)
  ), A = d(
    () => a("config", "useCurrentEnv", n.value?.config?.useCurrentEnv, !0)
  ), g = async () => {
    t.value = !0, r.value = null;
    try {
      const C = f(e.stage), L = f(e.country);
      if (!C || !L) return;
      const R = Xe(C, L, $), h = await fetch(R, {
        headers: {
          Accept: "application/json",
          "Cache-Control": "no-cache"
        }
      });
      if (!h.ok)
        throw new Error(`HTTP error! status: ${h.status}`);
      const P = await h.json();
      n.value = P;
    } catch {
      r.value = new Error("Unknown error occurred");
    } finally {
      t.value = !1;
    }
  };
  return k(
    [e.stage, e.country],
    ([C, L]) => {
      !C || !L || g();
    },
    {
      immediate: !0
    }
  ), {
    isFeatureToggleLoaded: u,
    isFocMarket: c,
    isPersonalizationEnabled: i,
    isOneTeaserHomeEnabled: l,
    isOneTeaserCampaignEnabled: S,
    isFailOnMissingPriceEnabled: E,
    isUseCurrentEnvEnabled: A
  };
}
/*! aem-component-data-util 1.0.0 */
function et(e) {
  return typeof window < "u" ? (window.top || window).aemNamespace.componentData[e] : { payload: W()?.AEMContext?.payload, config: W()?.AEMContext?.config };
}
const wt = (e, n = {
  reactive: !0
}) => {
  const t = p([]), r = p(null);
  function o(a) {
    const u = a.querySelector("[data-slot-outlet]");
    if (!u || !u.children.length) return;
    const c = u.children[0].localName === "slot" ? u.children[0].assignedElements() : u.children, i = Array.from(c || []).map(
      (l) => l?.getAttribute("component-id")
    );
    t.value = [];
    for (const l of i) {
      if (!l) continue;
      const S = { payload: et(l).payload, componentId: l };
      t.value.push(S);
    }
  }
  return ne(() => {
    const a = f(e);
    if (!a || (o(a), !n.reactive)) return;
    r.value?.disconnect();
    const u = { childList: !0, subtree: !0 }, c = (l) => {
      l.some((E) => E.type === "childList") && o(a);
    };
    r.value = new MutationObserver(c);
    const i = a?.querySelector("[data-slot-outlet]");
    i && r.value.observe(i, u);
  }), { childElementConfigs: t, syncConfigs: o };
};
function Dt(e, n, t = se()) {
  const r = p();
  let o;
  const { unsubscribe: a } = t.subscribe(ye, (i) => {
    o = i, c(f(e), f(n));
  });
  function u(i) {
    return r.value?.tileData && r.value?.state === "SUCCESS" && r.value?.inflateId === i;
  }
  function c(i, l) {
    if (i) {
      if (l) {
        r.value = {
          tileData: { ...l, state: "SUCCESS" },
          state: "SUCCESS",
          inflateId: i
        };
        return;
      }
      if (!u(i)) {
        if (!o || i && !o?.tileData?.[i])
          r.value = {
            // waiting for connection
            state: "PENDING",
            inflateId: i ?? "no-inflate-id-could-be-determined"
          };
        else if (i) {
          const S = o?.tileData?.[i], E = S?.state;
          r.value = {
            tileData: S,
            state: E,
            inflateId: i
          };
        }
      }
    }
  }
  return k(
    [() => f(e), () => f(n)],
    ([i, l]) => {
      c(i, l);
    },
    { immediate: !0 }
  ), { tileDataBundle: r, unsubscribe: a };
}
function Nt(e) {
  const n = d(() => f(e) === "campaign"), t = d(() => f(e) === "overlapping"), r = d(() => f(e) === "workbench7"), o = d(() => f(e) === "vt2025"), a = d(() => f(n) || t.value || r.value ? "classic" : "vt2025"), u = d(() => f(a) === "classic");
  return {
    isAppearanceCampaign: n,
    isAppearanceOverlapping: t,
    isAppearanceWorkbench: r,
    isAppearanceVt2025: o,
    cssProject: a,
    useWbClasses: u
  };
}
/**
* @preserve
* Licenses of bundled dependencies can be found in dependencies-licenses.txt
*/
const tt = { mq1: 320, mq2: 480, mq3: 768, mq4: 1024, mq5: 1280, mq6: 1440 }, nt = "wbresize", st = ["mq2", "mq3", "mq4", "mq5", "mq6"];
class w {
  constructor(n = window) {
    let t = w.smap.get(n);
    t || (t = function(r) {
      const o = st.map((A) => [A, r.matchMedia(`(min-width: ${tt[A]}px)`)]).reverse();
      let a, u, c, i = 0;
      const l = () => c ??= requestAnimationFrame(S);
      function S() {
        c = void 0, a = u, u = E(), r.dispatchEvent(new CustomEvent(nt, { detail: { current: u, previous: a } }));
      }
      function E() {
        for (const [A, g] of o) if (g.matches) return A;
        return "mq1";
      }
      return { getCurrentMediaQuery: E, observe: function(A = !1) {
        if (A && S(), i === 0) for (const [, g] of o) g.addEventListener("change", l);
        i++;
      }, disconnect: function() {
        if (i--, i === 0) for (const [, A] of o) A.removeEventListener("change", l);
      } };
    }(n), w.smap.set(n, t)), Object.assign(this, t);
  }
}
w.smap = /* @__PURE__ */ new Map();
var rt = Object.defineProperty, at = ((e) => (e.Undefined = "undefined", e.Null = "null", e.String = "string", e.Number = "number", e.SpecialNumber = "number", e.Boolean = "boolean", e.BigInt = "bigint", e))(at || {}), ot = ((e) => (e.Array = "array", e.Date = "date", e.Map = "map", e.Object = "object", e.RegularExpression = "regexp", e.Set = "set", e.Channel = "channel", e.Symbol = "symbol", e))(ot || {}), it = typeof window < "u" ? window : {};
(() => {
  var e;
  let n = !1;
  try {
    (e = it.document) == null || e.addEventListener("e", null, Object.defineProperty({}, "passive", { get() {
      n = !0;
    } }));
  } catch {
  }
  return n;
})();
(() => {
  try {
    return new CSSStyleSheet(), typeof new CSSStyleSheet().replaceSync == "function";
  } catch {
  }
  return !1;
})();
((e, n) => {
  for (var t in n) rt(e, t, { get: n[t], enumerable: !0 });
})({}, { err: () => Ee, map: () => ut, ok: () => Y, unwrap: () => ct, unwrapErr: () => lt });
var Y = (e) => ({ isOk: !0, isErr: !1, value: e }), Ee = (e) => ({ isOk: !1, isErr: !0, value: e });
function ut(e, n) {
  if (e.isOk) {
    const t = n(e.value);
    return t instanceof Promise ? t.then((r) => Y(r)) : Y(t);
  }
  if (e.isErr) return Ee(e.value);
  throw "should never get here";
}
var ct = (e) => {
  if (e.isOk) return e.value;
  throw e.value;
}, lt = (e) => {
  if (e.isErr) return e.value;
  throw e.value;
}, H = (e) => {
  const n = e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return new RegExp(`(^|[^@]|@(?!supports\\s+selector\\s*\\([^{]*?${n}))(${n}\\b)`, "g");
};
H("::slotted"), H(":host"), H(":host-context");
const St = { attributes: !0, childList: !1, subtree: !1, attributeFilter: ["dir"] };
class Et {
  constructor(n) {
    this.targetEl = n, this.createObserver(), this.observe();
  }
  setDir(n) {
    this.targetEl.setAttribute("dir", n);
  }
  get dir() {
    return this.targetEl.getAttribute("dir");
  }
  get isRtl() {
    return this.dir === "rtl";
  }
  get isLtr() {
    return !this.isRtl;
  }
  dispatchDirChangeEvent() {
    const n = new CustomEvent("wbdirchange", { detail: { dir: this.dir } });
    document.dispatchEvent(n);
  }
  createObserver() {
    this.observer = new MutationObserver(() => this.dispatchDirChangeEvent());
  }
  observe() {
    this.observer.observe(this.targetEl, St);
  }
}
new w(window);
new Et(document.documentElement);
function Bt(e = window) {
  return {
    currentStaticMediaQuery: new w(e).getCurrentMediaQuery()
  };
}
function kt(e, n, t, r) {
  const o = (a) => {
    t(), a.disconnect(), r?.logger?.debug(`fired load event for ${e} and query ${n}`);
  };
  k(
    e,
    (a) => {
      const u = f(a);
      if (u) {
        const c = (l, S) => {
          if (!u.shadowRoot) throw new Error("element does not have a shadowRoot");
          const E = u.shadowRoot.querySelector(n);
          if (E && "complete" in E && E.complete)
            o(S);
          else if (E)
            E.addEventListener("load", () => {
              o(S);
            });
          else throw new Error("cannot find element or element is not of <img> type");
        };
        new MutationObserver(c).observe(u, { childList: !0 });
      }
    },
    { immediate: !0 }
  );
}
/*! connection-aem-tracking 2.8.0 */
const de = "OWC_TRACKING_MANAGER", J = "PUSH_TRACKING_EVENT", ee = { trackingEvents: [] };
new class extends ge {
  constructor() {
    super(de);
  }
  get initialState() {
    return ee;
  }
  getReducer() {
    return (e = ee, n) => n.type === this.getActionType(J) ? { ...e, trackingEvents: [...e.trackingEvents, n.payload] } : e;
  }
  getPublicDispatchers() {
    return { pushTrackingEvent: (e) => (window.top?.dataLayer_ow.push(e), this.getAction(J, e)) };
  }
}();
const dt = () => se().getConnectionDispatchers(de).then((e) => e);
function Ct(e) {
  return _e() ? (me(e), !0) : !1;
}
function Ce(e) {
  return typeof e == "function" ? e() : pe(e);
}
const ft = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const At = (e) => e != null, U = () => {
};
function V(e) {
  var n;
  const t = Ce(e);
  return (n = t?.$el) != null ? n : t;
}
const fe = ft ? window : void 0;
function pt() {
  const e = p(!1), n = ve();
  return n && ne(() => {
    e.value = !0;
  }, n), e;
}
function _t(e) {
  const n = pt();
  return d(() => (n.value, !!e()));
}
function mt(e, n, t = {}) {
  const {
    root: r,
    rootMargin: o = "0px",
    threshold: a = 0.1,
    window: u = fe,
    immediate: c = !0
  } = t, i = _t(() => u && "IntersectionObserver" in u), l = d(() => {
    const C = Ce(e);
    return (Array.isArray(C) ? C : [C]).map(V).filter(At);
  });
  let S = U;
  const E = p(c), A = i.value ? k(
    () => [l.value, V(r), E.value],
    ([C, L]) => {
      if (S(), !E.value || !C.length)
        return;
      const R = new IntersectionObserver(
        n,
        {
          root: V(L),
          rootMargin: o,
          threshold: a
        }
      );
      C.forEach((h) => h && R.observe(h)), S = () => {
        R.disconnect(), S = U;
      };
    },
    { immediate: c, flush: "post" }
  ) : U, g = () => {
    S(), A(), E.value = !1;
  };
  return Ct(g), {
    isSupported: i,
    isActive: E,
    pause() {
      S(), E.value = !1;
    },
    resume() {
      E.value = !0;
    },
    stop: g
  };
}
function vt(e, n = {}) {
  const { window: t = fe, scrollTarget: r, threshold: o = 0 } = n, a = p(!1);
  return mt(
    e,
    (u) => {
      let c = a.value, i = 0;
      for (const l of u)
        l.time >= i && (i = l.time, c = l.isIntersecting);
      a.value = c;
    },
    {
      root: r,
      window: t,
      threshold: o
    }
  ), a;
}
var Lt = /* @__PURE__ */ ((e) => (e.CAMPAIGN = "campaign", e.SLEEK = "sleek", e.YOUNGSTARS = "young_stars", e.RICH = "rich", e))(Lt || {});
const te = {
  eventName: "view_promotion",
  category: "impression",
  label: void 0
  // no label for impression regarding documentation
}, Gt = {
  eventName: "select_promotion",
  category: "link",
  label: "teaser"
  /* TEASER */
}, Pt = {
  eventName: "select_promotion",
  category: "link"
  /* LINK */
};
function $t(e, n) {
  let t = null;
  Le(async () => {
    t ||= await dt();
  });
  function r(a, u) {
    const c = p(!1), i = vt(a), l = k(
      i,
      (S) => {
        S && !c.value && (c.value = !0, u ? o(te, u) : o(te), l?.());
      },
      { immediate: !0 }
    );
  }
  async function o(a, u) {
    const c = {
      event: "click",
      eventDetail: {
        name: a.eventName,
        category: a.category,
        action: `banner.${e}`,
        label: a.label,
        URL: a.URL ?? void 0,
        promotion: u
      },
      application: {
        id: "seamless_emh",
        version: "",
        subId: "vehicles",
        type: void 0,
        parentApplicationId: "aem",
        businessUnit: n?.value?.toLowerCase() ?? void 0
      }
    };
    typeof requestIdleCallback == "function" ? requestIdleCallback(() => {
      t?.pushTrackingEvent(c);
    }) : t?.pushTrackingEvent(c);
  }
  return {
    track: o,
    trackVisibility: r
  };
}
const x = {
  MERCEDES_BENZ: {
    LEFT: ["A_CLASS", "B_CLASS", "CLA_CLASS", "GLA_CLASS", "GLB_CLASS", "EQA_CLASS", "EQB_CLASS", "EQT_CLASS"],
    CENTER: ["C_CLASS", "GLC_CLASS", "E_CLASS", "CLE_CLASS", "V_CLASS", "EQV_CLASS"],
    // temp solution: Removing EQE_CLASS, long term adjustments in inflate
    RIGHT: ["GLE_CLASS", "EQE_CLASS", "EQS_CLASS", "GLS_CLASS", "G_CLASS", "S_CLASS"]
  },
  MERCEDES_AMG: {
    LEFT: ["A_CLASS", "CLA_CLASS"],
    CENTER: ["C_CLASS", "GLC_CLASS", "E_CLASS", "EQE_CLASS"],
    RIGHT: ["GLE_CLASS", "EQE_CLASS", "EQS_CLASS", "GLS_CLASS", "G_CLASS", "S_CLASS", "SL_CLASS", "GT_CLASS"]
  },
  MERCEDES_MAYBACH: {
    LEFT: ["GLS_CLASS"],
    CENTER: ["S_CLASS"],
    RIGHT: ["EQS_CLASS"]
  },
  get "Mercedes-Benz"() {
    return x.MERCEDES_BENZ;
  },
  get "Mercedes-AMG"() {
    return x.MERCEDES_AMG;
  },
  get "Mercedes-Maybach"() {
    return x.MERCEDES_MAYBACH;
  }
};
function Ht(e) {
  return document.cookie.match(`(^|;)\\s*${e}\\s*=\\s*([^;]+)`)?.pop() || null;
}
const Ut = [
  "TR",
  "TH",
  "KR",
  "AU",
  "JP",
  "SG",
  "MY",
  "ZA",
  // 'ZS' in the fincalc list
  "NZ",
  "IN",
  "MX",
  "TW",
  "VN",
  "BR",
  "EG"
], Vt = {
  LEFT: ["SPRINTER"],
  CENTER: ["VITO", "CITAN"],
  RIGHT: ["eCITAN", "eSPRINTER", "eVITO"]
};
function xt(e) {
  if (!e.includes("_CLASS"))
    return { model: void 0, blankModel: void 0, body: e.replace(/^_+/, "") };
  const [n, t, ...r] = e.split("_");
  if (t && t !== "CLASS")
    throw new Error(`Invalid model identifier, expected anything_CLASS, got ${n}_${t} instead`);
  return { model: `${n}_${t}`, blankModel: n, body: r.join("_") || null };
}
const Qt = (e, n) => e.map((t, r) => ht(t, r, n)), ht = (e, n, t) => ({
  id: void 0,
  name: "not set",
  creative: e.split("/").pop(),
  position: `banner_${t}.${n}`
}), zt = (e, n) => {
  e.ctrlKey || e.metaKey ? window.open(n, "_blank") : window.location.assign(n);
};
function* Yt(...e) {
  const n = e.map((t) => t[Symbol.iterator]());
  for (; ; ) {
    const t = n.map((r) => r.next());
    if (t.some(({ done: r }) => r)) break;
    yield t.map(({ value: r }) => r);
  }
}
const qt = (e) => ["B2B", "B2C"].includes(e);
export {
  Gt as BannerClickEvent,
  Lt as BannerType,
  Zt as COMPONENT_ID_SYMBOL,
  an as ComponentCategory,
  Pt as CtaClickEvent,
  Kt as DARK_MODE_SUBBRANDS,
  Wt as DEFAULT_BRAND,
  te as ImpressionEvent,
  $ as ONE_TEASER,
  Ut as OVERSEAS_MARKETS,
  Xt as PHRASE_COMPARE,
  Jt as PHRASE_DCP,
  en as PHRASE_ONE_TEASER,
  on as Severity,
  Ot as VEHICLE_TILE,
  un as aemLoaded,
  x as brandToModelMap,
  Xe as buildConfigServiceUrl,
  ht as convertBannerItemToTrackingItem,
  Qt as convertBannerItemsToTrackingItems,
  Fe as convertBrandToOurs,
  cn as country,
  ln as environment,
  Ht as findInPageCookies,
  qt as isContextType,
  Sn as language,
  tn as locale,
  En as logError,
  nn as market,
  dn as marketId,
  ye as mbtiDiscoAirConnectionName,
  Ze as parseEnvironment,
  Vt as positionDefinesModel,
  Cn as raise,
  xt as splitModelBodyInputUnderscored,
  zt as urlLinkout,
  fn as useAemEnvironmentConnection,
  Nt as useAppearance,
  $t as useBannerTracking,
  Tt as useBrand,
  It as useConfigService,
  wt as useDummyConfig,
  An as useErrorCapturer,
  sn as useI18n,
  Bt as useMediaQuery,
  kt as useSubscribeToLoadEventInShadowRoot,
  _n as useUuid,
  Dt as useVehicleTileData,
  Yt as zip
};
//# sourceMappingURL=index.js.map
